import React from 'react';
import './Skeletons.css';

const HorizontalPillSkeleton = ({ count = 4 }) => {
    return (
        <div className="horizontal-skeleton-wrapper">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="skeleton-pill-item shimmer-bg"></div>
            ))}
        </div>
    );
};

export default HorizontalPillSkeleton;
